













import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { EmailHistoryEventSource } from "@/employer/types";
import { useEmailHistoryStore } from "@/employer/store/emailHistory";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class EmailHistoryRawEvent extends Vue {

  emailHistoryStore = useEmailHistoryStore();

  @Prop()
  source: EmailHistoryEventSource;

  @Prop()
  id: number;

  @Prop()
  messageId: string;

  get isLoaded () {
    return this.source === EmailHistoryEventSource.Okta || this.emailHistoryStore.isRawDataLoaded(this.id);
  }

  get rawEvent () {
    return this.source === EmailHistoryEventSource.Okta
      ? this.emailHistoryStore.oktaRawData(this.messageId)
      : this.emailHistoryStore.rawData(this.id);
  }

  mounted () {
    if (this.source === EmailHistoryEventSource.AWS) {
      this.emailHistoryStore.loadRawEvent(this.id);
    }
  }
}
